import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import {
  Player,
  BigPlayButton,
  ControlBar,
  LoadingSpinner,
  Shortcut
} from "video-react";
import { setSelectItem, unsetSelectItem } from "../../actions/ClientAction";
import "../../../node_modules/video-react/dist/video-react.css";
import { getFormatTime } from "../../utils/formatVideoTime";
import "./video-view.css";
import CommentIcon from "../../assets/icons/comment-icon.svg";
import { setIsVideoTagActive, unsetIsVideoTagActive, unsetVideoTagClicked } from '../../actions/CommentAction'

export class VideoView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listViewStyle: null,
      currentPosition: "00:00"
    };

    this.handleStateChange = this.handleStateChange.bind(this);
  }

  componentDidMount() {
    const { startFullScreen, from } = this.props;
    this.player.subscribeToStateChange(this.handleStateChange);
    // this.player.subscribeToStateChange(this.handleStateChange.bind(this));
    if (startFullScreen) this.player.toggleFullscreen();

    if (from === "list") {
      this.setState({
        listViewStyle: true
      });
    } else {
      this.setState({
        listViewStyle: false
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { isDartOpen, isVersionsShowCompareOpen, isExpandOpen } = this.props;

    if (prevProps.isDartOpen !== isDartOpen && isDartOpen) {
      this.handlePause();
    }
    if (
      prevProps.isVersionsShowCompareOpen !== isVersionsShowCompareOpen &&
      isVersionsShowCompareOpen
    ) {
      this.handlePause();
    }
    if (prevProps.isExpandOpen !== isExpandOpen && isExpandOpen) {
      this.handlePause();
    }
  }

  handleStateChange(state, prevState) {
    const {
      currentPosition: oldCurrentPosition
    } = this.state;

    const newCurrentPosition = state.currentTime;
    if(oldCurrentPosition !== newCurrentPosition){
      this.setState({
        currentPosition: getFormatTime(state.currentTime)
      });
    }
    
    // added

    if (this.props.updateRefValue2) {
      this.props.updateRefValue2(getFormatTime(state.currentTime));
    }

    const { startFullScreen } = this.props;
    if (!startFullScreen) return;
    if (prevState.isFullscreen && !state.isFullscreen) {
      setTimeout(() => {
        this.props.onCloseFromFullScreen();
      }, 100);
    }
  }

  handlePlay = () => {
    this.player.play();
  };

  handlePause = () => {
    this.player.pause();
  };

  handleOnMouseEnter = () => {
    const { isHoverPlay } = this.props;
    if (isHoverPlay) this.handlePlay();
  };

  handleOnMouseLeave = () => {
    const { isHoverPlay } = this.props;
    if (isHoverPlay) this.handlePause();
  };

  handleMiddleView = () => {
    const { keyCollection, r, indice, from } = this.props;

    if (keyCollection && r && indice && from && r.isSelected !== true) {
      this.props.setSelectItem(keyCollection, r, from, indice);
    }
  };

  handleVideoTag = () => {
    const { isVideoTagActive,
      setIsVideoTagActive,
      unsetIsVideoTagActive,
      showCommentComponent,
      isShowComments
    } = this.props;

    const {
      currentPosition
    } = this.state;


    if (!isShowComments) {
      showCommentComponent()
      setIsVideoTagActive(currentPosition);
      this.handlePause();
    } else {
      if (isVideoTagActive) {
        unsetIsVideoTagActive();
        this.handlePause();
      } else {
        setIsVideoTagActive(currentPosition)
        this.handlePause();
      }
    }
  }

  render() {
    const {
      url,
      muted,
      disableDefaultControls,
      paddingTop,
      autoPlay,
      divWidth,
      loop,
      timePickerEnabled,
      videoTagClicked,
    } = this.props;

    const { listViewStyle, currentPosition } = this.state;
    if (videoTagClicked && videoTagClicked.isClicked) {
      if (this.player) {
        this.player.seek(videoTagClicked.time)
      }
      this.props.unsetVideoTagClicked()
    }
    return (
      <React.Fragment>
        {listViewStyle && (
          <div
            onContextMenu={e => e.preventDefault()}
            onClick={this.handleMiddleView}
            style={{
              width: divWidth ? divWidth : 80,
              marginLeft: 10,
              cursor: "pointer"
            }} // bajar width
            onMouseEnter={this.handleOnMouseEnter}
            onMouseLeave={this.handleOnMouseLeave}
          >
            <Player
              loop={loop ? true : false}
              autoPlay={autoPlay}
              fluid={true}
              muted={muted}
              ref={player => {
                this.player = player;
              }}
            >
              <LoadingSpinner />
              <BigPlayButton position="center" />
              <Shortcut clickable={false} shortcuts={this.handleShortCuts} />
              <ControlBar
                disableCompletely={disableDefaultControls}
                disableDefaultControls={disableDefaultControls}
              />
              <source src={url} />
            </Player>
          </div>
        )}
        {!listViewStyle && (
          <div
            onContextMenu={e => e.preventDefault()}
            onClick={this.handleMiddleView}
            style={{ paddingTop }}
            onMouseEnter={this.handleOnMouseEnter}
            onMouseLeave={this.handleOnMouseLeave}
          >
            <Player
              loop={loop ? true : false}
              autoPlay={autoPlay}
              fluid={true}
              muted={muted}
              ref={player => {
                this.player = player;
              }}
            >
              <LoadingSpinner />
              <BigPlayButton position="center" />
              <Shortcut clickable={false} shortcuts={this.handleShortCuts} />
              <ControlBar
                disableCompletely={disableDefaultControls}
                disableDefaultControls={disableDefaultControls}
              />
              <source src={url} />
            </Player>
          </div>
        )}
        <div>
          <button hidden id="buttonPause" onClick={() => this.handlePause()}>
            {" "}
            pausa
          </button>
        </div>
        <div className="video-view-wrapper">
          {timePickerEnabled && <div 
            className='video-ind-wrapper'
            onClick={this.handleVideoTag}
          >
            <div className='video-ind-img-wrapper'>
              <img src={CommentIcon} alt="O" className='video-ind-img'/>
            </div>
            <p>{`Comentar ${currentPosition}`}</p>
          </div>}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let commentsAndversionAware = {};
  if (ownProps.canCommentsAndVersions) {
    commentsAndversionAware = {
      isDartOpen: state.comments.show,
      isVersionsShowCompareOpen: state.comments.versionsShowCompare,
      isExpandOpen:
        state.assetsLastUploads.data.filter(lu => lu.isExpandSelected).length ||
        state.searcher.data.filter(s => s.isExpandSelected).length ||
        state.assetsExplore.data.filter(ae => ae.isExpandSelected).length ||
        state.assetsFavorites.data.filter(af => af.isExpandSelected).length ||
        state.assetsShared.data.filter(as => as.isExpandSelected).length
    };
  }

  return {
    ...commentsAndversionAware,
    videoTagClicked: state.comments.videoTagClicked,
    isExpandOpen:
      commentsAndversionAware.isExpandOpen ||
      state.assetsPublicShared.data.filter(ap => ap.isExpandSelected).length
  };
};

const mapDispatchToProps = {
  setSelectItem,
  unsetSelectItem,
  setIsVideoTagActive,
  unsetIsVideoTagActive,
  unsetVideoTagClicked
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(VideoView))
);
